var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFanBlowerFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_2",
    "data-name": "Frame 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M9.71,29.45c-.15,0-.31,0-.47-.01a9.623,9.623,0,0,1-5.13-1.6A3.774,3.774,0,0,1,2.26,25.3a1.975,1.975,0,0,1,.56-1.52,19.679,19.679,0,0,1,9.96-5.49,4.062,4.062,0,0,1,1.24-.22,1.341,1.341,0,0,1,1.2.55,2.649,2.649,0,0,1-.05,2.12l-1.2,5.45a3.988,3.988,0,0,1-3.31,3.2A6.044,6.044,0,0,1,9.71,29.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M14.03,18.39c1.79,0,.85,2.21.85,2.21l-1.22,5.5a3.62,3.62,0,0,1-3.01,2.95,5.256,5.256,0,0,1-.93.07c-.15,0-.3,0-.46-.01A9.33,9.33,0,0,1,4.3,27.57a3.4,3.4,0,0,1-1.71-2.31A1.651,1.651,0,0,1,3.06,24a19.567,19.567,0,0,1,9.77-5.39,4.326,4.326,0,0,1,1.2-.22m0-.64a4.527,4.527,0,0,0-1.34.24A20.036,20.036,0,0,0,2.6,23.57a2.3,2.3,0,0,0-.65,1.78,4.061,4.061,0,0,0,1.98,2.77,9.966,9.966,0,0,0,5.3,1.66c.16.01.33.01.48.01a6.043,6.043,0,0,0,1.02-.07,4.252,4.252,0,0,0,3.55-3.43l1.22-5.47a2.786,2.786,0,0,0,0-2.37,1.621,1.621,0,0,0-1.47-.7Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M18.97,16.04a1.341,1.341,0,0,1-1.2-.55,2.649,2.649,0,0,1,.05-2.12l1.2-5.45a3.988,3.988,0,0,1,3.31-3.2,5.871,5.871,0,0,1,.95-.07c.15,0,.31,0,.47.01a9.623,9.623,0,0,1,5.13,1.6A3.774,3.774,0,0,1,30.73,8.8a1.975,1.975,0,0,1-.56,1.52,19.679,19.679,0,0,1-9.96,5.49,4.051,4.051,0,0,1-1.24.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M23.29,4.98c.15,0,.3,0,.46.01a9.33,9.33,0,0,1,4.96,1.54,3.4,3.4,0,0,1,1.71,2.31,1.668,1.668,0,0,1-.48,1.27,19.567,19.567,0,0,1-9.77,5.39,4.207,4.207,0,0,1-1.19.22c-1.79,0-.85-2.21-.85-2.21L19.35,8a3.62,3.62,0,0,1,3.01-2.95,5.256,5.256,0,0,1,.93-.07m0-.65a6.043,6.043,0,0,0-1.02.07,4.252,4.252,0,0,0-3.55,3.43L17.5,13.3a2.786,2.786,0,0,0,0,2.37,1.626,1.626,0,0,0,1.47.69,4.527,4.527,0,0,0,1.34-.24A20.036,20.036,0,0,0,30.4,10.54a2.3,2.3,0,0,0,.65-1.78,4.061,4.061,0,0,0-1.98-2.77,9.966,9.966,0,0,0-5.3-1.66Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M13.93,16.22a3.926,3.926,0,0,1-1.3-.27L7.07,14.77A3.9,3.9,0,0,1,3.8,11.53a7.07,7.07,0,0,1-.06-1.4A9.165,9.165,0,0,1,5.38,5.1,3.845,3.845,0,0,1,7.97,3.29a.97.97,0,0,1,.17-.01,2.1,2.1,0,0,1,1.38.56,18.908,18.908,0,0,1,5.6,9.76,2.352,2.352,0,0,1-.02,2.12,1.372,1.372,0,0,1-1.17.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M8.13,3.61a1.792,1.792,0,0,1,1.16.47,18.818,18.818,0,0,1,5.5,9.57c.6,1.84-.12,2.24-.86,2.24a3.589,3.589,0,0,1-1.17-.24l-5.62-1.2A3.589,3.589,0,0,1,4.13,11.5a6.48,6.48,0,0,1-.06-1.36A8.776,8.776,0,0,1,5.64,5.29,3.426,3.426,0,0,1,7.99,3.62a.66.66,0,0,1,.14-.01m0-.65a1.34,1.34,0,0,0-.2.01A4.155,4.155,0,0,0,5.11,4.91a9.514,9.514,0,0,0-1.7,5.21,7.368,7.368,0,0,0,.06,1.48,4.243,4.243,0,0,0,3.5,3.49l5.59,1.19a4.219,4.219,0,0,0,1.36.27,1.647,1.647,0,0,0,1.42-.64,2.647,2.647,0,0,0,.07-2.41,19.433,19.433,0,0,0-5.7-9.9,2.358,2.358,0,0,0-1.58-.64Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M22.95,29.71a5.6,5.6,0,0,1-.99-.07h0a3.977,3.977,0,0,1-3.27-3.19l-1.22-5.52a2.523,2.523,0,0,1-.04-2.06,1.341,1.341,0,0,1,1.2-.55,4.511,4.511,0,0,1,1.28.23,19.634,19.634,0,0,1,9.92,5.48,1.951,1.951,0,0,1,.56,1.52,3.742,3.742,0,0,1-1.85,2.54,9.71,9.71,0,0,1-5.13,1.6A3.541,3.541,0,0,1,22.95,29.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M18.63,18.65a4.207,4.207,0,0,1,1.19.22,19.567,19.567,0,0,1,9.77,5.39,1.641,1.641,0,0,1,.48,1.27,3.417,3.417,0,0,1-1.71,2.31,9.3,9.3,0,0,1-4.96,1.54c-.15.01-.31.01-.46.01a5.256,5.256,0,0,1-.93-.07A3.62,3.62,0,0,1,19,26.37l-1.22-5.5s-.95-2.21.85-2.22m0-.64h0a1.648,1.648,0,0,0-1.47.69,2.788,2.788,0,0,0,0,2.37l1.21,5.45a4.257,4.257,0,0,0,3.56,3.45,5.965,5.965,0,0,0,1.02.07c.16,0,.32,0,.48-.01a9.966,9.966,0,0,0,5.3-1.66,4.061,4.061,0,0,0,1.98-2.77,2.3,2.3,0,0,0-.65-1.78,20.036,20.036,0,0,0-10.09-5.58,4.585,4.585,0,0,0-1.34-.23Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M16.46,19.83a2.851,2.851,0,0,1-2.02-.82,2.777,2.777,0,0,1,0-3.98,2.91,2.91,0,0,1,4.05,0,2.777,2.777,0,0,1,0,3.98A2.875,2.875,0,0,1,16.46,19.83Zm0-3.66a.869.869,0,0,0-.62.25.845.845,0,0,0,0,1.2.886.886,0,0,0,.62.25.869.869,0,0,0,.62-.25.845.845,0,0,0,0-1.2A.869.869,0,0,0,16.46,16.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M16.46,14.53a2.559,2.559,0,0,1,1.8.73,2.457,2.457,0,0,1,0,3.52,2.584,2.584,0,0,1-3.6,0,2.457,2.457,0,0,1,0-3.52,2.559,2.559,0,0,1,1.8-.73m0,3.66a1.211,1.211,0,0,0,.85-.34,1.153,1.153,0,0,0,0-1.66,1.194,1.194,0,0,0-.85-.34,1.211,1.211,0,0,0-.85.34,1.153,1.153,0,0,0,0,1.66,1.275,1.275,0,0,0,.85.34m0-4.31a3.185,3.185,0,0,0-2.25.91,3.1,3.1,0,0,0,0,4.45,3.237,3.237,0,0,0,4.5,0,3.1,3.1,0,0,0,.94-2.22,3.063,3.063,0,0,0-.94-2.22,3.152,3.152,0,0,0-2.25-.92Zm0,3.66a.552.552,0,0,1-.39-.16.514.514,0,0,1-.15-.37.523.523,0,0,1,.16-.37.555.555,0,0,1,.78,0,.508.508,0,0,1,0,.74.6.6,0,0,1-.4.16Z",
    fill: "#404041"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 33,
    height: 33,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanBlowerFrame2);
export default __webpack_public_path__ + "static/media/fan_blower_frame2.997f43d91683bb51dc4d7ec00634f4ee.svg";
export { ForwardRef as ReactComponent };